import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AutoComplete, ListEditable } from '../../../../../../../components'
import { FUNCTIONS } from '../../../../../../../utils'
import { groupBy } from 'lodash'

/**
 * Contact Job Functions: Form Component
 */
class Functions extends Component {
  /**
   * ComponentDidMount
   */
  componentDidMount () {
    const { job, onValueChange } = this.props
    const options = job && job.functions
    onValueChange(this.getFunctions(options))
  }

  /**
   * Prepopulate Functions on Edit
   * @param options
   * @returns {*[]}
   */
  getFunctions = (options) => {
    const existing = (FUNCTIONS || [])
      .filter((option) => (options || []).includes(option.value))

    const values = groupBy(FUNCTIONS, (option) => (option && option.value))
    const outside = (options || [])
      .filter((option) => option && !values[option])
      .map((option) => {
        return {
          label: option,
          value: option
        }
      })

    return [].concat(outside, existing)
  }

  /**
   * On list item delete
   * @param item
   */
  onDelete = (item) => {
    const { functions, onValueChange } = this.props
    const options = (functions || [])
      .filter((option) => (option && option.value) !== (item && item.value))
      .map((option) => option && option.value)

    onValueChange(this.getFunctions(options))
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { functions, onValueChange } = this.props

    return (
      <>
        <div className='field field--text'>
          <label className='field_label'>Functions</label>
          <AutoComplete
            name='functions'
            placeholder='Select'
            value={functions}
            isMulti
            isDefaultList
            clearable={false}
            closeMenuOnSelect={false}
            options={FUNCTIONS}
            onChange={onValueChange} />
        </div>
        <ListEditable
          listKey='value'
          items={functions}
          onDelete={this.onDelete} />
      </>
    )
  }
}

Functions.propTypes = {
  job: PropTypes.object,
  functions: PropTypes.array,
  onValueChange: PropTypes.func.isRequired
}

export default Functions